<template>
  <div class="container">

    <div class="row width_full">
      <div class="col_12">
        <div class="customer_content">
          <div class="common_subtitle pb_20">
            <h3 class="mb_0">Page Sorting</h3>
            <router-link class="btn btn_success" style="float: right" :to="{name:'pages', params:{type:$route.params.type}}"> Go Back</router-link>
          </div>
          <div class="dragable_clm">
            <nested-draggable :pages="pages" :child="false" v-if="pages.length > 0" @deleteItem="deleteRecord" @editPage="editPage" @changeSort="changeSort" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NestedDraggable from "./shared/NestedPage";
export default {
  name: "Sort",
  components: {NestedDraggable},
  data(){
    return {
      pages: [],
      sort: '1',
      sortable: {
        order: 'id',
        sort: 'desc'
      },
      filter: {
        status: '',
        per_page: 10
      },
      columns: [
        {
          label: "Name",
          field: "name",
          sortable: true
        },
        {
          label: "Menu",
          field: "name",
          sortable: true
        },

        {
          label: "Action",
          field: 'action',
          sortable: false,
          slot: true,
        }
      ],
      pagination: null,
      queryParams: {
        page: 1,
        search: '',
        search_columns: 'title',
        sort: 'title',
        sort_order: 'asc',
        page_type: this.$route.params.type,
      },
    }
  },
  created() {
    this.loadPages()
  },
  methods:{
    sorting({column, order}) {
      this.queryParams.sort = column;
      this.queryParams.sort_order = order;
    },
    pageChanged(page) {
      this.queryParams.page = page;
    },
    loadPages(){
      this.axios.get('/pages', {
        params: {...this.queryParams, ...this.filter}
      }).then((response) => {
        this.pages = response.data.data;
        this.pagination = response.data.meta;
      })
    },
    deleteRecord(id) {
      this.$swal({
        title: 'Are you sure want to delete?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        confirmButtonColor: '#dd4b39',
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.axios.delete('/pages/'+id).then(() => {
            this.category = null
            this.showForm = false
            this.$swal.fire(
                'Deleted',
                'Page has been deleted!',
                'success'
            )
            this.loadPages();
          });
        }
      });
    },

    changeSort(categories){
      this.axios.post('/pages/sort', {categories: categories})
          .then(() => {
            this.showSuccessMsg('Page Sort Updated!')
          })
    },
    editPage(id){
      console.log(id)
    },
  }
}
</script>

<style scoped>

</style>